import React, { FC } from 'react';
import PartWithIDDisplay from '../parts_detail_details_page/PartWithIDDisplay';

const PartWithStockedDropdownDisplay: FC<any> = ({ part }) => {
	return (
		<div className="flex max-w-full flex-row items-center justify-between">
			<PartWithIDDisplay part={part} numberMaxChars={64} nameLengthPercentage={80} />
			<div className="text-gray-400">{part.isStocked ? 'Stocked' : 'Not Stocked'}</div>
		</div>
	);
};

export default PartWithStockedDropdownDisplay;
